// Module
var code = "<svg fill=none viewBox=\"0 0 24 24\" stroke=currentColor> <path stroke-linecap=round stroke-linejoin=round stroke-width=2 d=\"M13 17h8m0 0V9m0 8l-8-8-4 4-6-6\"/> </svg> ";
// Exports
module.exports = code;